import { ToggleSwitch } from "@/components/atoms/ToggleSwitch/ToggleSwitch";
import { FormField, InputFormField } from "@/overlay/components/form-field";
import type { PortfolioEnergyPoiOptions } from "@/reducer/client-models/PoiOptions";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { useFlag } from "@openfeature/react-sdk";
import { EnergyPortfolioSelector } from "./EnergyPortfolioSelector";
import "./portfolio-energy.scss";

export function PortfolioEnergyPoiPanel(props: {
  options: PortfolioEnergyPoiOptions;
  onChangeOptions: (options: PortfolioEnergyPoiOptions) => void;
}) {
  const { value: enabled } = useFlag("portfolio_manager", false);
  return (
    <div className="portfolio-energy-panel">
      {enabled ? (
        <PortfolioEnergySettings
          key={props.options.portfolioId}
          options={props.options}
          onChange={props.onChangeOptions}
        />
      ) : (
        <p className="portfolio-energy-message portfolio-energy-message--warning" role="status">
          <Trans>Portfolio Energy is currently unavailable.</Trans>
        </p>
      )}
    </div>
  );
}

function PortfolioEnergySettings(props: {
  options: PortfolioEnergyPoiOptions;
  onChange: (options: PortfolioEnergyPoiOptions) => void;
}) {
  function changeDisplay(display: Partial<PortfolioEnergyPoiOptions["display"]>) {
    props.onChange({
      ...props.options,
      display: { ...props.options.display, ...display },
    });
  }
  return (
    <>
      <EnergyPortfolioSelector
        currentPortfolioId={props.options.portfolioId}
        includedAssetIds={props.options.includedAssetIds || undefined}
        onApply={(portfolio, includedAssetIds) =>
          props.onChange({ ...props.options, portfolioId: portfolio.id, includedAssetIds })
        }
        onIncludedAssetIdsChange={(includedAssetIds) => props.onChange({ ...props.options, includedAssetIds })}
      />
      <FormField label={t`Cluster dense assets`}>
        <ToggleSwitch
          checked={props.options.display.clusteringEnabled}
          onChange={(clusteringEnabled) => changeDisplay({ clusteringEnabled })}
        />
      </FormField>
      <FormField label={t`Show MW values`}>
        <ToggleSwitch
          checked={props.options.display.showMwValues}
          onChange={(showMwValues) => changeDisplay({ showMwValues })}
        />
      </FormField>
      <FormField label={t`Show asset names`}>
        <ToggleSwitch
          checked={props.options.display.showAssetNames}
          onChange={(showAssetNames) => changeDisplay({ showAssetNames })}
        />
      </FormField>
      <InputFormField
        label={t`Marker size`}
        type="range"
        min="0.05"
        max="0.2"
        step="0.01"
        value={props.options.display.markerSize}
        onChange={(event) => changeDisplay({ markerSize: Number(event.target.value) })}
      />
    </>
  );
}
